
import { computed } from '@vue/composition-api'
import { BaseDate } from '@/app/shared/utils/Date'

export default function futureDateRange (props) {
  const MAX_DATE_RANGE = 45

  const minDateFrom = computed(() => {
    return new Date()
  })

  const maxDateFrom = computed(() => {
    return new Date(props.dateTo)
  })

  const minDateTo = computed(() => {
    return new Date(props.dateFrom)
  })

  const maxDateTo = computed(() => {
    return new BaseDate(props.dateFrom).addDays(MAX_DATE_RANGE).toDate
  })

  return { minDateFrom, minDateTo, maxDateFrom, maxDateTo }
}



// WEBPACK FOOTER //
// ./src/app/shared/compositions/FutureDateRange.js